export default __webpack_public_path__ + "static/media/pencil-828282.1549f339.svg";